import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { CommonService } from './common.service';
import { environment } from 'src/environments/environment';
import { UserInfoService } from './userInfo.service';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private _refreshNeeded$ = new Subject<void>();
  notifyCount$ = new Subject<number>();
  infoUpdateCount$ = new Subject<number>();
  localBasePath = '/notification';
  localBasePathWithS = '/notifications';
  commonHeaders = new HttpHeaders({
    'Accept-Version': 'V2',
    'X-Tenant-ID': this.userInfoService.userDetails.tenantID
  });

  constructor(private http: HttpClient,
    private commonService: CommonService,
    readonly userInfoService: UserInfoService
  ) { }

  get refreshNeeded$() {
    return this._refreshNeeded$;
  }

  updatenotification(id) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.putCall(environment.API_BASE_PATH + this.localBasePathWithS + `?view_status=seen&vendor_id=${id}`, {}, headers);
  }

  updateInfonotification(id, type) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    let body = {
      "user_id": id,
      "type": type,
    }
    return this.commonService.postCall(environment.API_BASE_PATH + `/status`, body, headers);
  }

  getInfoNotificationCount(id: string): Observable<any> {
    if (!id)
      return;
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.http.get(environment.API_BASE_PATH + `/status/count?user_id=${id}`, headers)
  }

  getAlertAndNotification(index, rows, column, direction, search) {
    if (index == null && rows == null) {
      let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
      return this.commonService.getCall(environment.API_BASE_PATH + this.localBasePathWithS, headers);
    } else {
      let headers = { headers: { 'starting_index': String(index), 'max_rows': String(rows), 'sort_by': String(column), 'sort_dir': String(direction), 'search': String(search), 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
      return this.commonService.getCall(environment.API_BASE_PATH + this.localBasePathWithS, headers);
    }
  }

  getAlertAndNotificationbyvendorid(vendorId, index, rows, column, direction, search) {
    if (index == null && rows == null) {
      let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
      return this.commonService.getCall(environment.API_BASE_PATH + this.localBasePathWithS + `/vendor/${vendorId}`, headers);
    } else {
      let headers = { headers: { 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search), 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
      return this.commonService.getCall(environment.API_BASE_PATH + this.localBasePath + `/vendor/${vendorId}`, headers);
    }
  }

  getNotificationcount(id: string) {
    if (!id)
      return;
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.getCall(environment.API_BASE_PATH + this.localBasePathWithS + `/count?view_status=unseen&vendor_id=${id}`, headers);
  }

  getNotificationcountseen(id: string) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.getCall(environment.API_BASE_PATH + this.localBasePathWithS + `/count?view_status=seen&vendor_id=${id}`, headers);
  }

  getNotificationcountunseen(id: string) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.getCall(environment.API_BASE_PATH + this.localBasePathWithS + `/count?view_status=unseen&vendor_id=${id}`, headers);
  }

  deletenotificationvendorbyid(id, conId) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.deleteCall(environment.API_BASE_PATH + `/notification?chargebox_id=${id}&connector_id=${conId}`, headers);
  }


}